<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { Select, ListItem } from 'svelte-materialify';

  export let className = '';
  export let items: any[] = [];
  export let subtitles: any[] = [];
  export let displayKey = '';
  export let bindKey = '';
  export let subtitleKey = '';
  export let selectedItem: any;

  const dispatch = createEventDispatcher();
  let selectedItemValue = selectedItem;

  $: list = items.map((item, idx) => {
    return {
      name: getDisplayName(item),
      value: getDisplayName(item),
      subtitle: getSubtitle(item, idx),
    };
  });
  $: onValueChange(selectedItemValue);
  $: onSelectedItemChange(selectedItem);

  function onSelectedItemChange(selectedItem: any) {
    selectedItemValue = selectedItem;
  }

  function onValueChange(selectedItemValue: any) {
    if (Array.isArray(selectedItemValue)) {
      selectedItem = null;
    } else {
      const item = items.find(
        (i) =>
          getDisplayName(i) === selectedItemValue ||
          (bindKey && i[bindKey] === selectedItemValue)
      );

      if (!item) return;

      selectedItem = bindKey ? item[bindKey] : item;
    }

    dispatch('select', selectedItem);
  }

  function getDisplayName(item: any) {
    if (!item) return null;

    return displayKey ? item[displayKey] : item;
  }

  function getSubtitle(item: any, idx: number) {
    if (!item) return null;

    return subtitleKey ? item[subtitleKey] : subtitles?.[idx];
  }
</script>

<Select class={className} items={list} bind:value={selectedItemValue} let:item>
  <slot />
  <div slot="item">
    <ListItem value={item.value}>
      <span>{item.name}</span>
      <span slot="subtitle">
        {#if item.subtitle}
          {item.subtitle}
        {/if}
      </span>
    </ListItem>
  </div>
</Select>
